export const container = {
    width: '100%', display: 'flex', flexDirection: 'column'
}

export const containerObs = {
    width: '100%',
    marginBottom: '10px'
}

export const textArea = { width: '100%', height: '100px' }
